import { EstablishmentInterface } from "../interfaces/EstablishmentInterface";

interface ActiveEstablishmentInterface {
    id: number;
    name: string;
    address: string;
}

export const getActiveEstablishment = (
    establishments: EstablishmentInterface[],
    activeEstablishmentId?: number,
): ActiveEstablishmentInterface | null => {
    if (!activeEstablishmentId) {
        return null;
    }

    const activeEstablishment = establishments.find(
        (establishment: EstablishmentInterface) =>
            establishment.id === activeEstablishmentId,
    );

    if (!activeEstablishment) return null;

    return {
        id: activeEstablishment.id,
        name: activeEstablishment.name,
        address: `${activeEstablishment.address.street} ${activeEstablishment.address.house_number}${
            activeEstablishment.address.house_number_addition
                ? " " + activeEstablishment.address.house_number_addition
                : ""
        }, ${activeEstablishment.address.zip_code}, ${activeEstablishment.address.city}`,
    };
};
